/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Review_Con1Inputs */

const en_fc_home_review_con1 = /** @type {(inputs: Fc_Home_Review_Con1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Still alpha. The team rates it about 56% ready for production work.`)
};

/**
* | output |
* | --- |
* | "Still alpha. The team rates it about 56% ready for production work." |
*
* @param {Fc_Home_Review_Con1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_review_con1 = /** @type {((inputs?: Fc_Home_Review_Con1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Review_Con1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_review_con1(inputs)
});
export { fc_home_review_con1 as "fc.home.review.con1" }